<app-promote-banner></app-promote-banner>

<div id="home">
  <app-step-one></app-step-one>
  <app-step-two></app-step-two>
  <app-step-three></app-step-three>
  <div id="step4">
    <app-carousel-features [data]="features" title="homepage.step4.title" subTitle="homepage.step4.subTitle"
      type="videos"></app-carousel-features>
  </div>
  <app-step-five></app-step-five>
  <div id="pricing">
    @defer (on viewport) {
    <app-step-six />
    } @placeholder {
    <p translate>{{ 'compatibility.brands.loading' }}</p>
    }
  </div>
</div>